import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1fca2a94"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"1.5rem"},
  class: "pi pi-info-circle"
}, null, -1))
const _hoisted_2 = { class: "p-ml-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user-edit" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-globe" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadImage = _resolveComponent("UploadImage")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Inplace = _resolveComponent("Inplace")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitUpdateUser && _ctx.submitUpdateUser(...args)), ["prevent"])),
    autocomplete: "off"
  }, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _hoisted_1,
        _createTextVNode(" " + _toDisplayString(_ctx.$t("workspaceLayout.infos")), 1)
      ]),
      subtitle: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.user?.email), 1)
      ]),
      content: _withCtx(() => [
        _createVNode(_component_UploadImage, {
          src: _ctx.getImage(_ctx.user?.image, 'users'),
          modelValue: _ctx.image,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.image) = $event)),
          height: 100
        }, null, 8, ["src", "modelValue"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Inplace, {
            class: "p-my-3",
            closable: true,
            active: _ctx.active[0],
            "onUpdate:active": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.active[0]) = $event))
          }, {
            display: _withCtx(() => [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_ctx.form.name.$value || _ctx.user?.name), 1)
            ]),
            content: _withCtx(() => [
              _createVNode(_component_InputText, {
                modelValue: _ctx.form.name.$value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.name.$value) = $event)),
                class: _normalizeClass([{ 'p-invalid': _ctx.form.name.$hasError }, "p-mr-3"]),
                placeholder: _ctx.$t('category.name')
              }, null, 8, ["modelValue", "class", "placeholder"])
            ]),
            _: 1
          }, 8, ["active"]),
          _createVNode(_component_Inplace, {
            closable: true,
            active: _ctx.active[1],
            "onUpdate:active": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.active[1]) = $event))
          }, {
            display: _withCtx(() => [
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.$tm("languages")[_ctx.form.language].label), 1)
            ]),
            content: _withCtx(() => [
              _createVNode(_component_Dropdown, {
                modelValue: _ctx.form.language,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.language) = $event)),
                options: (_ctx.$tm('languages') as any),
                optionLabel: "label",
                optionValue: "id",
                class: "p-mr-3"
              }, null, 8, ["modelValue", "options"])
            ]),
            _: 1
          }, 8, ["active"])
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          loading: _ctx.loading,
          style: {"width":"100%"},
          class: "p-button-outlined p-button-success",
          icon: "pi pi-save",
          label: _ctx.$t('save'),
          type: "submit"
        }, null, 8, ["loading", "label"])
      ]),
      _: 1
    })
  ], 32))
}